export default [
  { key: 'global_showall_label', value: 'all' },
  { key: 'global_jobfamily_administration', value: '8019' },
  { key: 'global_jobfamily_communicationadvertising', value: '8020' },
  { key: 'global_jobfamily_designcreation', value: '8021' },
  { key: 'global_jobfamily_finance', value: '8023' },
  { key: 'global_jobfamily_generalmanagement', value: '8743' },
  { key: 'global_jobfamily_humanresources', value: '8024' },
  { key: 'global_jobfamily_informationsystems', value: '8025' },
  { key: 'global_jobfamily_marketing', value: '8028' },
  { key: 'global_jobfamily_productionmanufacturing', value: '8022' },
  { key: 'global_jobfamily_purchasingsupplychain', value: '8027' },
  { key: 'global_jobfamily_researchdevelopment', value: '8215' },
  { key: 'global_jobfamily_retail', value: '8029' },
  { key: 'global_jobfamily_sales', value: '8030' },
  { key: 'global_jobfamily_other', value: '8216' }
]
